// src/components/timelineData.js

export const timelineData = [
    {
      year: 2001,
      title: 'O INÍCIO',
      content: "Insatisfeito com o desempenho dos produtos de cuidados com carros e iates que vendia para o Sudeste Asiático e com a incapacidade e falta de vontade do fabricante de investir em P&D, o Dr. Drew Gill utiliza seu conhecimento adquirido em seu PhD em Física Quântica para desenvolver o C1 Crystal Lacquer e forma a Gtechniq.",
      image: '/images/2001.webp'
    },
    {
      year: 2006,
      title: 'PRIMEIRO CONTRATO',
      content: "A Gtechniq conquista seu primeiro contrato substancial para detalhar e proteger a maior frota de Rolls-Royces do mundo, pertencente ao The Peninsula Hotel, em Hong Kong. Todos os veículos foram polidos e protegidos com Gtechniq P1 Nanocomposite Polish e C1 Crystal Lacquer.",
      image: '/images/2006.webp'
    },
    {
      year: 2006,
      title: 'EUROPE HQ',
      content: "Rob Earle compra os direitos europeus da Gtechniq e estabelece a primeira sede europeia em King's Langley, no Reino Unido. Neste estágio, a Gtechniq tinha 7 produtos, nomeadamente C1 Crystal Lacquer, C3 Smart Carnauba, P1 Nanocomposite Polish, um conjunto de pads de polimento e MF1 Microfibre Cloth.",
      image: '/images/2006a.webp'
    },
    {
      year: 2008,
      title: 'ECOMMERCE',
      content: "A Gtechniq lança seu primeiro site de comércio eletrônico com uma linha de produtos muito ampliada de 20 produtos, incluindo a adição de C4 Permanent Trim Restorer, C5 Wheel Armour, L1 Leather Guard, C2 Liquid Crystal e I1 Smart Fabric.",
      image: '/images/2008.webp'
    },
    {
      year: 2011,
      title: 'REDE DE APLICADORES',
      content: "A rede Gtechniq Accredited Detailer foi lançada. Nosso primeiro centro de Detalhamento Credenciado, Ultimate Finish, abre ao lado do circuito de corrida de Brands Hatch.",
      image: '/images/2011.webp'
    },
    {
      year: 2012,
      title: 'EXO',
      content: "O EXO Ultra Durable Hybrid Coating é lançado. Com sua aplicação super fácil e desempenho hidrofóbico excepcional, torna-se um sucesso instantâneo e, ao longo de suas várias atualizações, permanece como um dos nossos 3 produtos mais vendidos.",
      image: '/images/2012.webp'
    },
    {
      year: 2014,
      title: 'CRYSTAL SERUM',
      content: "O Crystal Serum é lançado. Não é apenas a fórmula mais resistente a riscos e produtos químicos que já testamos em nosso laboratório de intemperismo, mas também oferece brilho e lisura de superfície incomparáveis.",
      image: '/images/2014.webp'
    },
    {
      year: 2014,
      title: 'GTECHNIQ BRASIL',
      content: "A distribuição oficial da Gtechniq no Brasil começa, liderada por Diego Cavalcante, um experiente detailer e entusiasta automotivo. Diego trouxe a Gtechniq para o Brasil após uma cuidadosa pesquisa, reconhecendo a marca como líder em revestimentos cerâmicos de alta qualidade.",
      image: '/images/diego.webp'
    },
    {
      year: 2016,
      title: 'GTECHNIQ AMERICA DO NORTE',
      content: "A Gtechniq North America é lançada na feira anual SEMA. A Gtechniq North America, sediada em Atlanta, Georgia, torna-se uma presença crescente na indústria de Detalhamento da América do Norte, com uma rápida adoção em seu programa de Detalhadores Credenciados.",
      image: '/images/2016.webp'
    },
    {
      year: 2017,
      title: 'CRYSTAL SERUM ULTRA 10H',
      content: "O Crystal Serum Ultra é lançado na SEMA 2017. Esta nova fórmula aprimorada é o resultado direto de um grande esforço de P&D para sintetizar uma nova nanopartícula de 7nm para preencher os espaços entre a nanopartícula pré-existente de 20nm. Isso proporciona uma grande melhoria na dureza e resistência química do filme curado.",
      image: '/images/2017.webp'
    },
    {
      year: 2020,
      title: 'LINHA MARINE',
      content: "A Gtechniq lança a nova linha Marine. Esta linha inclui Ceramic Base e Ceramic Top, oferecendo uma garantia de três anos. Outros produtos notáveis incluem o Fabric Coat, que oferece impermeabilização inigualável, além de proteção contra mofo e bolor, e o primeiro produto de proteção aplicável com mangueira do mundo, o Rinse-On Ceramic.",
      image: '/images/2020.webp'
    },
    {
      year: 2022,
      title: 'LINHA BIKE',
      content: "A Gtechniq traz sua inovadora tecnologia de superfície inteligente para ciclistas. Depois de se tornar o nome de referência em detalhamento automotivo, a Gtechniq Bike traz aos ciclistas o mesmo nível de cuidado para suas bicicletas. A Gtechniq Bike é parceira técnica da Pinarello.",
      image: '/images/2022.webp'
    }
  ];
